import React from "react";
import { Link } from "react-router-dom";
import { LI, UL } from "../../../AbstractElements";

const MyStore = () => {
  return (
    <LI className="profile-nav onhover-dropdown" title="My Store">
      <i className="icofont icofont-ui-home"></i>
      <UL className="profile-dropdown onhover-show-div simple-list">
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/payment-types`}>
            <span>Pay Types</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/sales-history`}>
            <span>Sales History</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/sales-trends`}>
            <span>Sales Trends</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/sales-by-department`}>
            <span>Sales by Department</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/sales-by-vendor`}>
            <span>Sales by Vendor</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/my-store/transaction-type`}>
            <span>Transaction Type</span>
          </Link>
        </LI>
      </UL>
    </LI>
  );
};

export default MyStore;
